// Base Libraries
import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Switch, HashRouter, Route, Redirect } from "react-router-dom";
import i18n from "INTL/i18n";

// Components

import PaymentConfirmation from "../Payer/PaymentConfirmation";
import PaymentSuccess from "../Payer/PaymentSuccess";
import PaymentError from "../Payer/PaymentError";
import PaymentFailed from "../Payer/PaymentFailed";
import NotFound from "../NotFound/NotFound";
import { history} from "MODULES/Tracking";

// Constants
import { ROUTES } from "../../constants/routeConstants";
import { ARABIC } from "../../utils/constants";

export class App extends React.Component {
  render() {
    return (
      // <I18nextProvider i18n={i18n}>
      <div className="App" dir={this.props.locale === ARABIC ? "rtl" : "ltr"}>
        
        <HashRouter history={history}>
          <Switch>
            <Route
              path={ROUTES.PAYMENT_CONFIRMATION}
              component={PaymentConfirmation}
              exact
            />
            <Route
              path={ROUTES.PAYMENT_SUCCESS}
              component={PaymentSuccess}
              exact
            />
            <Route
              path={ROUTES.PAYMENT_FAILURE}
              component={PaymentError}
              exact
            />
            <Route
              path={ROUTES.PAYMENT_CANCEL}
              component={PaymentFailed}
              exact
            />
            <Route path="/notfound" component={NotFound} exact />
            <Route path={ROUTES.DEFAULT} component={NotFound} exact />
          </Switch>
        </HashRouter>
      </div>
      // </I18nextProvider >
    );
  }
}

App.propTypes = {
  locale: PropTypes.string,
};
const mapStateToProps = state => {
  return {
    locale: i18n.language,
  };
};

const mapDispatchToProps = dispatch => ({
  dispatch,
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(App);



// WEBPACK FOOTER //
// ./src/modules/App/App.js